// Which address to put in the "play on your phone" QR code, and whether a
// phone can actually reach it.

const LOCAL_ONLY_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]', '0.0.0.0']);

/** True for addresses that only resolve on this computer (a phone can't open them). */
export function isLocalOnly(hostname) {
  const h = hostname.toLowerCase();
  return LOCAL_ONLY_HOSTS.has(h) || h.endsWith('.localhost') || h.startsWith('127.');
}

/**
 * The address a phone should open: `path` on the current origin, without the
 * current page's query or hash. Works on production, preview links and a dev
 * server's network address alike.
 */
export function phoneUrl(location, path = '/') {
  return new URL(path, location.origin).href;
}
